import BaseIconButton from '../ui/BaseIconButton';
import { BaseIconButtonProps } from '@/components/ui/BaseIconButton';
import '@/styles/components/layout/CardIconButton.scss';

export default function CardIconButton({ children, ...props }: BaseIconButtonProps) {
    return (
        <BaseIconButton className={`card-icon-button ${props.color}`} {...props}>
            {children}
        </BaseIconButton>
    );
}
